import React, {useEffect, useState} from "react";
import {Button, Col, Row, Table, Dropdown, DropdownButton} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import {ControlledMenu, MenuItem, useMenuState} from "@szhsin/react-menu";
import {useAuth} from "../../providers/authprovider";
import useAlert from "../../components/CustomAlert";
import Loading from "../../components/LoadingInfo";
import ConfirmDeleteElementDialog from "../../components/forms/ConfirmDeleteElementDialog";


export default function OfferTemplates({privilege}){

    const navigate = useNavigate();
    const {alert, showAlert} = useAlert();
    const {offers:{templates: templatesApi}} = useAuth();
    const [menuProps, toggleMenu] = useMenuState();
    const [anchorPoint, setAnchorPoint] = useState({x: 0, y: 0});
    const [currentContextTemplate, setCurrentContextTemplate] = useState(undefined);
    const [templateToDelete, setTemplateToDelete] = useState(undefined);
    const [templates, setTemplates] = useState(undefined);

    useEffect(()=>{
        if(templates !== undefined) return;

        templatesApi.list(({success, error, content})=>{
            if(!success)
                return showAlert(error);

            setTemplates(content);
        })
    })

    if(!templates) return <Loading />;

    const navigateBack = ()=>{navigate('/offers')}

    const handleCreateNewTemplate = (offerType)=>{
        navigate(`/offers/templates/create/${offerType}`);
    }

    const handleEditTemplate = ()=>{
        if(currentContextTemplate)
            navigate(`/offers/templates/edit/${currentContextTemplate.id}`);
    }

    const handleDeleteTemplate = ()=>{
        if(!currentContextTemplate) return;

        setTemplateToDelete(currentContextTemplate);
    }

    const confirmDeleteTemplate = ()=>{
        if(!templateToDelete) return;

        templatesApi.remove(templateToDelete.id, ({success, error, content})=>{
            if(!success)
                return showAlert(error);

            setTemplates(prev => prev.filter(t => t.id !== content.id));
        })
    }

    function handleTemplateContextMenu(e, template){
        e.preventDefault();
        setAnchorPoint({x: e.clientX, y: e.clientY});
        toggleMenu(true);
        setCurrentContextTemplate(template);
    }

    return (
        <>
            {alert()}
            <ConfirmDeleteElementDialog
                show={!!templateToDelete}
                onClose={() => setTemplateToDelete(undefined)}
                onConfirm={confirmDeleteTemplate}
                message={`Czy na pewno usunąć szablon "${templateToDelete?.name}" ?`}
            />
            <Row>
                <Col>
                    <Button variant={"outline-secondary"} className="mt-3 mb-3 me-4 float-start" onClick={navigateBack}><FontAwesomeIcon icon={faArrowLeft} /> Powrót</Button>
                </Col>
                <Col>
                    {
                        privilege.edit &&
                        <DropdownButton
                            className="mt-3 mb-3 me-4 float-end"
                            title="Nowy szablon"
                            id="bg-vertical-dropdown-template"
                        >
                            <Dropdown.Item eventKey="1" onClick={()=>handleCreateNewTemplate("offer_aeration")}>Napowietrzanie</Dropdown.Item>
                            <Dropdown.Item eventKey="2" onClick={()=>handleCreateNewTemplate("offer_smoke_removal")}>Oddymianie</Dropdown.Item>
                            <Dropdown.Item eventKey="3" onClick={()=>handleCreateNewTemplate("offer_simple")}>Prosta</Dropdown.Item>
                        </DropdownButton>
                    }
                </Col>
            </Row>
            {
                privilege.edit &&
                <ControlledMenu {...menuProps} anchorPoint={anchorPoint}
                                onClose={() => toggleMenu(false)}>
                    <MenuItem onClick={handleEditTemplate}>Edytuj</MenuItem>
                    <MenuItem onClick={handleDeleteTemplate}>Usuń</MenuItem>
                </ControlledMenu>
            }

            <Table size={"sm"} striped bordered hover>
                <thead>
                <tr>
                    <th>L.p</th>
                    <th>Nazwa</th>
                    <th>Wersja</th>
                    <th>Autor</th>
                    <th>Ostatnia zmiana</th>
                </tr>
                </thead>
                <tbody>
                {
                    templates.length === 0 ?
                        <tr>
                            <td colSpan={5} className="text-center text-muted">Brak szablonów</td>
                        </tr>
                        :
                        templates.map((template, lp)=>
                            <tr key={template.id} onClick={(e)=>handleTemplateContextMenu(e, template)}>
                                <td>{lp+1}</td>
                                <td>{template.name}</td>
                                <td>{template.version}</td>
                                <td>{template.user}</td>
                                <td>{template.updated_at?.substring(0,10)}</td>
                            </tr>
                        )
                }
                </tbody>
            </Table>
        </>
    )
}
